import util from '@utils/util';

/**
     * 个人页模块 组件
     * liveVideo
     */
export default {
  name: 'liveVideo',
  props: {
    liveList: Object,
    target: String,
    countryCode: String
  },
  methods: {
    KEWLSensorTrack: function KEWLSensorTrack(pathname) {
      util.KEWLSensorTrack({
        lmweb_clickText: '跳转',
        lmweb_tabName: pathname
      });
    },
    getLiveRoomLink: function getLiveRoomLink(vid) {
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      if (!vid) {
        return 'javascript:;';
      }
      var cc = util.getI18nLocale();
      // 带参传递
      var json = {
        pathname: "/".concat(cc, "/v/").concat(vid, "/index.html")
      };
      if (type) {
        json[type] = 1;
      }
      window.location.href = util.directToPath(json);
    }
  }
};